/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {ClockDialView, getClockPointerTransform} from './ClockDialUtils';

export interface ClockDialPointerProps {
  classes: Record<string, string>;
  selectedHour: number;
  selectedMinute: number;
  view: ClockDialView | null;
}

/**
 * Renders the clock hand and pointer thumb for the active dial value.
 *
 * ```typescript
 *
 * import {ClockDialPointer} from '@ion/dls/src/components/date/ClockDialPointer';
 *
 * <ClockDialPointer classes={classes}
 *   view={ClockDialView.Hours}
 *   selectedHour={9}
 *   selectedMinute={30} />
 *
 * ```
 */
export const ClockDialPointer = ({
  classes,
  selectedHour,
  selectedMinute,
  view
}: ClockDialPointerProps) => (
  <div className={classes.pointer}
    data-testid='digital-time-picker-clock-pointer'
    style={{transform: getClockPointerTransform(view, selectedHour, selectedMinute)}}>
    <div className={classes.pointerLine} />
    <div className={classes.pointerThumb} />
  </div>
);

export default memo(ClockDialPointer);
